import { Feature } from '@guest-widgets/shared/src/features';
import { useFeature } from '@guest-widgets/shared/src/contexts/featureContext/featureContext';

import type { Filters } from './filters';

export const useFeatureToggleFilters = () => {
  const { isEnabled } = useFeature();

  return (Object.keys(mapper) as Array<keyof Filters>).reduce(
    (features, filterKey) => ({
      ...features,
      [filterKey]: isEnabled(mapper[filterKey]),
    }),
    {} as FeatureToggleFilters
  );
};

export type FeatureToggleFilters = Record<keyof typeof mapper, boolean>;

const mapper: Record<keyof Filters, Feature> = {
  misc: Feature.MiscellaneousFilter,
  languages: Feature.LanguageFilter,
  sort: Feature.ProductSorting,
  price: Feature.PriceFilter,
  categories: Feature.CategoryFilter,
  location: Feature.LocationFilter,
  dates: Feature.DateFilter,
};
